import { PDFDocument } from 'pdf-lib';
import BaseAPI from './BaseAPI';

export default class extends BaseAPI {
  imageFormats = ['jpg', 'jpeg', 'png'];


  constructor() {
    super(import.meta.env.VITE_SITE_URL + '/files');
  }


  store(data) {
    if (this.isImageFile(data.file)) {
      return this.storeImageAsPdf(data);
    }

    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });

    return axios.post(this.url, formData, {
      'Content-Type': 'multipart/form-data',
    });
  }


  isImageFile(file) {
    const extension = file.name.split('.').pop();
    return this.imageFormats.includes(extension.toLowerCase());
  }


  storeImageAsPdf(data) {
    return data.file.arrayBuffer().then(async (arrayBuffer) => {
      var imageBytes = new Uint8Array(arrayBuffer);

      const pdfDoc = await PDFDocument.create();
      const page = pdfDoc.addPage();
      var pdfImage = null;

      const fileExtension = data.file.name.split('.').pop().toLowerCase();
      switch (fileExtension) {
        case 'jpg':
        case 'jpeg':
          pdfImage = await pdfDoc.embedJpg(imageBytes);
          break;

        case 'png':
          pdfImage = await pdfDoc.embedPng(imageBytes);
          break;

        default:
          throw new Error('Not implemented image type: \'' + fileExtension + '\'');
      }

      const widthRatio = page.getWidth() / pdfImage.width;
      const heightRatio = page.getHeight() / pdfImage.height;
      const scaleFactor = Math.min(widthRatio, heightRatio);
      const pdfDims = pdfImage.scale(scaleFactor);

      page.drawImage(pdfImage, {
        x: page.getWidth() / 2 - pdfDims.width / 2,
        y: page.getHeight() / 2 - pdfDims.height / 2,
        width: pdfDims.width,
        height: pdfDims.height,
      });

      const pdfBytes = await pdfDoc.save();
      data.file = new File([pdfBytes], data.file.name + '.pdf');

      return this.store(data);
    });
  }


  show(id) {
    return axios.get(`${ this.url }/${ id }`);
  }


  download(filename, url) {
    return new Promise((resolve, reject) => {
      axios.get(url, { responseType: 'blob' })
        .then(({ data }) => {
          const url = window.URL.createObjectURL(data);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  }


  indexByDate({ dueDate }, params = {}) {
    return axios.post(`${ this.url }/by-date`,
      {
        dueDate,
      },
      {
        params,
      });
  }


  downloadBase64(id) {
    return axios.get(`${ this.url }/download/base64/${ id }`);
  }
}
